import { useEffect } from 'react'
import { classes, style } from 'typestyle'
import { Link, useParams } from 'react-router-dom'

/* Common ======================================================================================= */
import { GLOBAL_CONTENTS } from '../../../common/global-contents'

/* Core ========================================================================================= */
import { addSnippet } from '../../../core/snippet-manager'

/* Hooks ======================================================================================== */
import useFetch from '../../../hooks/use-fetch'
import useLocal from '../../../hooks/use-local'

/* Common ======================================================================================= */
import { FIELDS } from '../../../share/fields'
import { FieldObject } from '../../../core/field-manager'
import { withRouter } from '../../../contexts/with-router'

/* Components =================================================================================== */
import Skeleton from '../../../components/skeleton'
import { Box } from '../../../components/box/box.component'
import { EvenMoreSimplerPagination } from '../../../modules/navigation/pagination'
import { Loader } from '../../../components/loader'
import { Snippet, SnippetHead, SnippetBody } from '../../../modules/layouts/snippet'
import { Text } from '../../../components/text/text.component'

/* Styles ======================================================================================= */
import { mb8 } from '../../../styles/styleset/margin/mb8'
import { p12 } from '../../../styles/styleset/padding/p12'
import { pb0 } from '../../../styles/styleset/padding/pb0'
import { mt8 } from '../../../styles/styleset/margin/mt8'
import { mt4 } from '../../../styles/styleset/margin/mt4'
import { ml8 } from '../../../styles/styleset/margin/ml8'
import { mr8 } from '../../../styles/styleset/margin/mr8'
import { mt16 } from '../../../styles/styleset/margin/mt16'
import { mb12 } from '../../../styles/styleset/margin/mb12'

export default addSnippet(
  'Activities',
  withRouter((props: any) => {
    const {
      url = '/a/groups/{{groupId}}/base/{{baseId}}/table/{{rowId}}',
      limit = 3,
      trigger,
    } = props
    const { groupId, rowId, baseId } = useParams()

    const ReplacementText = (props: any) => {
      const { label, type, group, route, url } = props
      const containerProps: any = { size: 'md' }
      const textProps: any = { size: 'md' }

      switch (type) {
        case 'user-profile':
          textProps.italic = true
          break
        case 'link':
          textProps.link = url
          containerProps.to = `${group}/${route}`
          break
      }
      return (
        <span {...containerProps}>
          {label &&
            (textProps.link ? (
              <Link to={url}>
                <Text {...textProps} size="sm" disableFlex semiBold>
                  {`${label}`.replace(/\\u002E/g, '.').trim()}
                </Text>
              </Link>
            ) : (
              <Text {...textProps} size="sm" disableFlex>
                {`${label}`.replace(/\\u002E/g, '.').trim()}
              </Text>
            ))}
        </span>
      )
    }

    const [local] = useLocal()
    const apiUrl = `${process.env.REACT_APP_API_URL}/a/snippets/activities/${groupId}`
    const [activities, $activities] = useFetch(
      { data: [], totalPage: 1, page: 1 },
      {
        url: apiUrl,
        search: {
          page: 1,
          limit: limit || 8,
          url: url
            .replace('{{groupId}}', groupId)
            .replace('{{rowId}}', rowId)
            .replace('{{baseId}}', baseId),
        },
      },
    )

    useEffect(() => {
      if (activities.mounted) {
        // $activities.get()
      }
    }, [activities.mounted])

    useEffect(() => {
      if (trigger) {
        // $activities.get()
      }
    }, [trigger])

    return (
      <Snippet>
        <SnippetHead title={GLOBAL_CONTENTS.activities[local]}>
          <EvenMoreSimplerPagination data={activities} $data={$activities} size="sm" />
        </SnippetHead>
        <SnippetBody>
          <Box baseline="none">
            <Loader
              loaded={activities.mounted && !activities.meta.isLoading}
              timeout={300}
              skeleton={
                <Box>
                  <Skeleton width="100%" height={72} />
                </Box>
              }
              component={
                <>
                  {activities.payload.data.length === 0 && !activities.meta.isLoading ? (
                    <Box baseline="surface" flex alignCenterY>
                      <Box baseline="none" fullWidth row>
                        <Text size="md" italic>
                          {GLOBAL_CONTENTS.noActivities[local]}
                        </Text>
                      </Box>
                    </Box>
                  ) : (
                    activities.payload.data.map((activity: any, key: any) => {
                      return (
                        <Box
                          baseline="background"
                          className={classes(p12, pb0, key !== 0 && mt16)}
                          row
                          alignCenterY
                          rounded
                          key={key}
                        >
                          <Box className={mb12} baseline="none" fullWidth row>
                            <Box baseline="none" className={mb8}>
                              <Text size="sm" baseline="surface" shrink uppercase semiBold lighter>
                                {new Date(activity.updatedAt).toLocaleString('en-CA')}
                              </Text>
                            </Box>
                            <Text size="sm" preWrap disableFlex>
                              {(() => {
                                function flatMap(array: any, fn: any) {
                                  let result: any = []
                                  for (let i = 0; i < array.length; i++) {
                                    const mapping = fn(array[i])
                                    result = result.concat(mapping)
                                  }
                                  return result
                                }

                                let log = [activity.body.log]

                                for (const key in activity.body.replacement) {
                                  for (let i = 0; i < log.length; i++) {
                                    const text = log[i]
                                    if (text && typeof text === 'string') {
                                      const result: any = flatMap(text.split(key), function(
                                        part: any,
                                      ) {
                                        return [
                                          part,
                                          <ReplacementText
                                            {...activity.body.replacement[key]}
                                            key={key}
                                            url={activity.body.url}
                                          />,
                                        ]
                                      })

                                      result.pop()
                                      const start = log.slice(0, i)
                                      const end = log.slice(i + 1, log.length - 1)

                                      log = [...start, ...result, , ...end]
                                      break
                                    }
                                  }
                                }

                                return log
                              })()}
                            </Text>
                            {activity.body.detail && (
                              <Box baseline="none" className={mt8}>
                                {(activity.body.detail || []).map((detail: any, key: any) => {
                                  const render = (props: {
                                    type: string
                                    value: any
                                    isPrev?: boolean
                                    customType?: any
                                  }) => {
                                    const { type, value, isPrev, customType } = props

                                    switch (type) {
                                      case FIELDS.RICH_TEXT:
                                        return (
                                          <Text
                                            baseline="background"
                                            size="sm"
                                            style={{ width: '100%', marginTop: 4 }}
                                            preLine
                                            light
                                          >
                                            <div
                                              dangerouslySetInnerHTML={{ __html: value }}
                                              className={style({
                                                maxWidth: '100%',
                                                maxHeight: 120,
                                                overflow: 'auto',
                                                $nest: { '*': { margin: 0 } },
                                              })}
                                            />
                                          </Text>
                                        )
                                      case FIELDS.CHECKBOX:
                                        return (
                                          <Text
                                            baseline="background"
                                            size="sm"
                                            className={mt4}
                                            style={{
                                              textDecoration: isPrev ? 'line-through' : '',
                                            }}
                                            preLine
                                            light
                                          >
                                            {value == 'true' ? 'Yes' : 'No'}
                                          </Text>
                                        )
                                      case FIELDS.ASYNC_SELECT:
                                        return (
                                          <Text
                                            baseline="background"
                                            size="sm"
                                            className={mt4}
                                            style={{
                                              textDecoration: isPrev ? 'line-through' : '',
                                            }}
                                            preLine
                                            light
                                          >
                                            {/* {typeof value === 'string' ? value || 'None' : 'None'} */}
                                          </Text>
                                        )
                                      case FIELDS.NUMBER:
                                        return (
                                          <Text
                                            baseline="background"
                                            size="sm"
                                            className={mt4}
                                            style={{
                                              textDecoration: isPrev ? 'line-through' : '',
                                            }}
                                            preLine
                                            light
                                          >
                                            {value != 'undefined' ? value : 0}
                                          </Text>
                                        )
                                      case FIELDS.CUSTOM_FIELD:
                                        const customField = FieldObject[customType]

                                        if (customField?.value) {
                                          const Value = customField.value
                                          return (
                                            <Text
                                              baseline="background"
                                              size="sm"
                                              className={mt4}
                                              style={{
                                                textDecoration: isPrev ? 'line-through' : '',
                                              }}
                                              preLine
                                              light
                                            >
                                              <Value value={value} field={{ fieldProps: {} }} />
                                            </Text>
                                          )
                                        }
                                      default:
                                        return (
                                          <Text
                                            baseline="background"
                                            size="sm"
                                            className={mt4}
                                            style={{
                                              textDecoration: isPrev ? 'line-through' : '',
                                            }}
                                            preLine
                                            light
                                          >
                                            {value != 'undefined' &&
                                            (typeof value === 'string' || typeof value === 'number')
                                              ? value || 'None'
                                              : 'None'}
                                          </Text>
                                        )
                                    }
                                  }
                                  const renderDivider = (type: string) => {
                                    switch (type) {
                                      case FIELDS.RICH_TEXT:
                                        return (
                                          <Text size="sm" className={classes(mr8, ml8, mt8)}>
                                            to
                                          </Text>
                                        )
                                      case FIELDS.ASYNC_SELECT:
                                        return (
                                          <Text size="sm" className={classes(mr8, ml8, mt8)}>
                                            {/* to */}
                                          </Text>
                                        )
                                      default:
                                        return (
                                          <Text size="sm" className={classes(mr8, ml8, mt4)}>
                                            to
                                          </Text>
                                        )
                                    }
                                  }

                                  return (
                                    <Box baseline="none" key={key} row>
                                      <Text semiBold size="sm">
                                        {detail.label}
                                      </Text>
                                      <Box
                                        baseline="none"
                                        style={{ flexWrap: 'wrap' }}
                                        flex
                                        alignCenterY
                                      >
                                        {render({
                                          ...detail,
                                          value: detail.prev || detail.value,
                                          isPrev: true,
                                        })}
                                        {renderDivider(detail.type)}
                                        {render(detail)}
                                      </Box>
                                    </Box>
                                  )
                                })}
                              </Box>
                            )}
                          </Box>
                        </Box>
                      )
                    })
                  )}
                </>
              }
            />
          </Box>
        </SnippetBody>
      </Snippet>
    )
  }),
)
